// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"94959aa2","513":"0e514c41"}[chunkId] + ".chunk.js";
};